module.exports = __webpack_public_path__ + "static/media/cuisinart.f2bff95e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/registry/aboutZolaBrands/cuisinart.png
 ** module id = 2308
 ** module chunks = 50
 **/